import React, { useContext } from "react";
import { usePrivacyCollection } from "@queries/usePrivacyCollection";
import { ApplicationContext } from "@context/ApplicationContext";
import Loader from "@components/Ui/Loader";
import "./style.scss";

const PrivacyCollection = () => {
    const { subscriberGroupId } = useContext(ApplicationContext);
    const { privacyCollectionNotice, isLoading } = usePrivacyCollection(subscriberGroupId);

    if (isLoading) {
        return <Loader isLoading={isLoading} />;
    }

    return (
        <div className="privacy-collection-notice__wrapper admin-content">
            {privacyCollectionNotice ? (
                // eslint-disable-next-line react/no-danger
                <div className="privacy-collection-notice__content" dangerouslySetInnerHTML={{ __html: privacyCollectionNotice }} />
            ) : (
                <p className="paragraph">Privacy collection notice content to follow</p>
            )}
        </div>
    );
};

export default PrivacyCollection;
